import { inject } from '@angular/core';
import { signalStore } from '@ngrx/signals';
import { withEntities } from '@ngrx/signals/entities';
import { withCursorPagination } from '@dgacontrol-frontend/shared-util-cursor-pagination';

import { BillingSubscriptionChargeLineService } from './generated/billing-subscription-charge-line/billing-subscription-charge-line.service';
import type { SubscriptionChargeLineV1 } from './generated/types';

/**
 * Lines of ONE subscription charge. COMPONENT-SCOPED, same shape as
 * `SetupChargeLinesStore` — but READ-ONLY: the backend exposes GET only.
 *
 * These lines are INFORMATIONAL: one row per SIM the user held in the period, and they do
 * NOT sum into the parent's `total_net`. Nothing to sync back to the parent store, which
 * is why this one does not inject `SubscriptionChargesStore`.
 *
 * ponytail: `loadMore` has no caller — a user holds 3 SIMs at most.
 */
export const SubscriptionChargeLinesStore = signalStore(
  withEntities<SubscriptionChargeLineV1>(),
  withCursorPagination<SubscriptionChargeLineV1, string>(() => {
    const api = inject(BillingSubscriptionChargeLineService);
    return (identity, cursor) =>
      api.billingV1SubscriptionChargeLinesList(
        { identity },
        { cursor: cursor ?? undefined },
      );
  }),
);
